import { UPDATE_CREATIVE_GROUP_SYNC, UPDATE_CREATIVE_SYNC } from './actions';

export const creativeGroup = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_CREATIVE_GROUP_SYNC:
      return action.groupData;
    default:
      return state;
  }
};

export const creative = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_CREATIVE_SYNC:
      return action.creativeData;
    default:
      return state;
  }
};
